/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StediPayer
 */
export interface StediPayer {
    /**
     * 
     * @type {string}
     * @memberof StediPayer
     */
    stedi_id: string;
    /**
     * 
     * @type {string}
     * @memberof StediPayer
     */
    primary_payer_id?: string;
    /**
     * 
     * @type {string}
     * @memberof StediPayer
     */
    display_name: string;
}

/**
 * Check if a given object implements the StediPayer interface.
 */
export function instanceOfStediPayer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stedi_id" in value;
    isInstance = isInstance && "display_name" in value;

    return isInstance;
}

export function StediPayerFromJSON(json: any): StediPayer {
    return StediPayerFromJSONTyped(json, false);
}

export function StediPayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): StediPayer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stedi_id': json['stedi_id'],
        'primary_payer_id': !exists(json, 'primary_payer_id') ? undefined : json['primary_payer_id'],
        'display_name': json['display_name'],
    };
}

export function StediPayerToJSON(value?: StediPayer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stedi_id': value.stedi_id,
        'primary_payer_id': value.primary_payer_id,
        'display_name': value.display_name,
    };
}

